import { render, staticRenderFns } from "./sidebar-filters-custom-filter-compact.vue?vue&type=template&id=52d91a6c&scoped=true&"
import script from "./sidebar-filters-custom-filter-compact.ts?vue&type=script&lang=ts&"
export * from "./sidebar-filters-custom-filter-compact.ts?vue&type=script&lang=ts&"
import style0 from "./sidebar-filters-custom-filter-compact.scss?vue&type=style&index=0&id=52d91a6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d91a6c",
  null
  
)

export default component.exports